import React from "react"
import { useAdminPreviewDocuments, useAdminPreviewDocument } from "@/lib/queries"
import { ClinicalReviewsListView } from "@/components/shared/ClinicalReviewsListView"

const pdfUrl = (slug: string) =>
  `/api/v1/admin/preview_documents/${slug}/pdf`

export function AdminClinicalReviewsPage() {
  const { data: docs = [], isLoading } =
    useAdminPreviewDocuments("clinical_review")

  return (
    <ClinicalReviewsListView
      docs={docs}
      isLoading={isLoading}
      useDocumentDetail={useAdminPreviewDocument}
      pdfUrl={pdfUrl}
    />
  )
}
